import React, { useEffect, useState } from "react";
import { Global } from "../helpers/Global";

export const ConfigurarAlertas = () => {
  const [alertas, setAlertas] = useState([]);
  const [modalEditar, setModalEditar] = useState(false);
  const [alertaSeleccionada, setAlertaSeleccionada] = useState(null);
  const [nuevoActivo, setNuevoActivo] = useState(false);
  const [nuevaHora, setNuevaHora] = useState("08:00");
  const [mensaje, setMensaje] = useState("");

  // 🟡 Obtener rol desde token decodificado o localStorage
  const token = localStorage.getItem("token");
  const payload = token ? JSON.parse(atob(token.split(".")[1])) : {};
  const rol = payload.rol || "empleado";

  const alertasDisponibles = [
    {
      agente: "resumenJornadas",
      descripcion: "Resumen diario de jornadas",
      requiereHora: true,
      roles: ["admin", "gerente"]
    },
    // ✅ NUEVA: Resumen diario de intervenciones
    {
      agente: "resumenIntervenciones",
      descripcion: "Resumen diario de intervenciones",
      requiereHora: true,
      roles: ["admin", "gerente"]
    },
    {
      agente: "fichajeTardio",
      descripcion: "Aviso por fichaje tardío",
      requiereHora: false,
      roles: ["admin", "gerente"]
    },
    {
      agente: "recordatorioFichaje",
      descripcion: "Recordatorio si no has fichado durante tu turno",
      requiereHora: false,
      roles: ["admin", "gerente", "usuario"]
    },
    {
      agente: "recordatorioPrevioTurno",
      descripcion: "Recordatorio antes de tu turno",
      requiereHora: true,
      roles: ["admin", "gerente", "usuario"]
    },
    {
      agente: "recordatorioFinTurno",
      descripcion: "Recordatorio al finalizar tu turno",
      requiereHora: false,
      roles: ["admin", "gerente", "usuario"]
    }
  ];

  // ✅ Filtrar alertas según el rol del usuario
  const alertasFiltradas = alertasDisponibles.filter((alerta) =>
    alerta.roles.includes(rol)
  );

  const cargarAlertas = async () => {
    try {
      const res = await fetch(`${Global.url}alertas`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setAlertas(data);
      }
    } catch (error) {
      console.error("Error al obtener alertas:", error);
    }
  };

  useEffect(() => {
    cargarAlertas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const abrirModalEditar = (alerta) => {
    const alertaActual = alertas.find((a) => a.agente === alerta.agente);
    setAlertaSeleccionada(alerta);
    setNuevoActivo(alertaActual?.activo ?? false);
    setNuevaHora(alertaActual?.hora_envio?.slice(0, 5) || "08:00");
    setMensaje("");
    setModalEditar(true);
  };

  const guardarCambios = async () => {
    try {
      const body = {
        agente: alertaSeleccionada.agente,
        activo: nuevoActivo,
        hora_envio:
          nuevoActivo && alertaSeleccionada.requiereHora ? nuevaHora : null
      };

      const res = await fetch(`${Global.url}alertas`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
      });

      if (res.ok) {
        setMensaje("Preferencias guardadas correctamente.");
        await cargarAlertas();
        setTimeout(() => setModalEditar(false), 1000);
      } else {
        setMensaje("Error al guardar.");
      }
    } catch (error) {
      console.error("Error al guardar alerta:", error);
      setMensaje("Error de conexión.");
    }
  };

  const obtenerEstado = (agente) => {
    const alerta = alertas.find((a) => a.agente === agente);
    return alerta?.activo ? "Activa" : "Desactivada";
  };

  // (Opcional) obtener hora para mostrarla en la tabla si aplica
  const obtenerHora = (agente) => {
    const alerta = alertas.find((a) => a.agente === agente);
    return alerta?.hora_envio ? alerta.hora_envio.slice(0, 5) : "-";
  };

  return (
    <div className="gestion-usuarios">
      <h2 className="centrar-titulo">Configuración de Alertas</h2>

      <div className="table-listado-padre">
        <table className="table-listado">
          <thead>
            <tr>
              <th>Alerta</th>
              <th>Estado</th>
              <th>Hora</th>{/* ← para las que la requieren */}
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {alertasFiltradas.map((alerta) => (
              <tr key={alerta.agente}>
                <td>{alerta.descripcion}</td>
                <td>{obtenerEstado(alerta.agente)}</td>
                <td>
                  {alerta.requiereHora ? obtenerHora(alerta.agente) : "-"}
                </td>
                <td>
                  <button
                    className="btn-mapa"
                    onClick={() => abrirModalEditar(alerta)}
                  >
                    Editar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* MODAL EDITAR ALERTA */}
      {modalEditar && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="modal-close" onClick={() => setModalEditar(false)}>
              &times;
            </button>
            <h3>Editar alerta: {alertaSeleccionada.descripcion}</h3>

            <label>
              <input
                type="checkbox"
                checked={nuevoActivo}
                onChange={(e) => setNuevoActivo(e.target.checked)}
              />
              Activar alerta
            </label>

            {nuevoActivo && alertaSeleccionada?.requiereHora && (
              <div className="form-group">
                <label>Hora de envío:</label>
                <input
                  type="time"
                  value={nuevaHora}
                  onChange={(e) => setNuevaHora(e.target.value)}
                />
              </div>
            )}

            {mensaje && <p className="rojo">{mensaje}</p>}

            <button className="btn-login" onClick={guardarCambios}>
              Guardar preferencias
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
